// extracted by mini-css-extract-plugin
export default {"ctaBlock":"CtaBlock-module--ctaBlock--aRbXj","innerContainer":"CtaBlock-module--innerContainer--ifBUK"};